<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div class="widget-location">
			<h3>결제내역</h3>
		</div>
		<div class="list-top">
			<div class="page-info">
				<span>전체 : <strong>{{total}}</strong> ( {{current_page}} / {{last_page}} 페이지 )</span>
			</div>
		</div>
		
		<el-table
			    :data="tableData"
			    stripe empty-text="데이타가 없습니다."
			    style="width: 100%">
			    <el-table-column
			      prop="pay_status_text"  v-if="!isMobile"
			      label="상태"
			      width="180">
			    </el-table-column>
				<el-table-column
				  label="결제명">
						<template slot-scope="scope">
							<div>{{ scope.row.order_sn }}</div>
							<div>{{ scope.row.payment_name }}</div>
							<!-- <div>개인결제</div>
							<div style="cursor:pointer;" > 입금계좌: 대구은행 9600553347462</div>
				            <div style="cursor:pointer;" > 입금자명: 이너해피 {{ scope.row.title }}</div>				            -->
				        </template>
				</el-table-column>
				<!-- <el-table-column
				  prop="price"
				  label="결제금액"
				  width="180">
				</el-table-column> -->
				<el-table-column
				  label="실결제금액"
				  width="180">
					<template slot-scope="scope">
						<span v-if="scope.row.currency === 'CNY'" style="font-weight: bold; color: #67c23a;">
							{{ scope.row.pay_amount_cny || '0.00' }} ¥
						</span>
						<span v-else style="font-weight: bold; color: #409eff;">
							{{ scope.row.pay_amount_krw || '0.00' }} ₩
						</span>
					</template>
				</el-table-column>
				<el-table-column
				  label="결제 통화"  v-if="!isMobile"
				  width="120"
				  align="center">
					<template slot-scope="scope">
						<el-tag :type="scope.row.currency === 'CNY' ? 'success' : 'primary'" size="small" effect="dark">
							{{ scope.row.currency }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column
				  prop="pay_type_text"  v-if="!isMobile"
				  label="결제수단"
				  width="180">
				</el-table-column>
				<el-table-column
				  prop="pay_time_text"  v-if="!isMobile"
				  label="결제일"
				  width="180">
				</el-table-column>
			</el-table>
			<div class="page">
				<el-pagination
					layout="prev, pager, next" :page-size="20"
					:total="total"  @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return{
				loading: true,
				total:0,
				page:1,
				current_page:1,
				last_page:1,
				tableData: [],
				
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList(){
				this.loading = true
				request.post('/member/Cybercash/getPayList', {
					page: this.page,
				}).then(response => {
					this.loading = false
					console.log(response,"getPayList")
					this.tableData = response.data.data;
					this.total = response.data.total;
					this.current_page = response.data.current_page;
					this.last_page = response.data.last_page;
				}).catch(() => {
					this.loading = false
				});
				
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
		}
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
		padding:0 10px;
	}
	
	.page{
		padding-top: 20px;
		text-align: center;
	}
	.text-primary {
	    color: #337ab7;
	}
	::v-deep .el-table__header th {
		color: #333; 
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		.page{
			padding-bottom: 20px;
		}
	}
</style>